import React, { useEffect, useMemo, useRef, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { Form, Table } from "react-bootstrap";
import { FaFile, FaFolder } from "react-icons/fa";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { useParams } from "react-router";
import { editorS3FileManagerServices } from "../../../APIServices/Editor/editorS3FileManagerServices";
import Swal from "sweetalert2";
import { BsFillFolderFill, BsImage } from "react-icons/bs";
import { GrDocumentCsv, GrDocumentExcel, GrDocumentPpt, GrDocumentRtf, GrDocumentTxt, GrDocumentWord } from "react-icons/gr";
import { GoFileZip } from "react-icons/go";
import { AiOutlineFilePdf } from "react-icons/ai";
import { IoFolder } from "react-icons/io5";

const RecycleBin = ({
  tableRef,
  onMouseDown,
  setFileFolderUpdater,
  fileFolderUpdater
}) => {
  const { studyId } = useParams()
  const [loader, setLoader] = useState([]);
  const [searchData, setSearchData] = useState("");
  const [viewType, setViewType] = useState("grid");
  const [selectedItems, setSelectedItems] = useState([]);
  const [fileManager, setFileManager] = useState([]);
  const [lastSelectedIndex, setLastSelectedIndex] = useState(null);
  const AppsRef = useRef(null);
  const gridRef = useRef(null);
  const tableDRef = useRef(null);
  const getS3EditorFolders = async () => {
    setSelectedItems([])
    setLoader(true);
    let data = await editorS3FileManagerServices.getS3EditorFolders(studyId, "trash", searchData, "", "both");
    setFileManager(data?.data || []);
    setLoader(false);
  };

  useEffect(() => {
    getS3EditorFolders();
  }, [searchData, fileFolderUpdater]);

  const isSelected = (fullPath) => selectedItems.includes(fullPath);

  const handleItemClick = (e, fullPath, index) => {
    if (e.shiftKey && lastSelectedIndex !== null) {
      const start = Math.min(lastSelectedIndex, index);
      const end = Math.max(lastSelectedIndex, index);
      const rangeIds = fileManager.slice(start, end + 1).map((f) => f.fullPath);
      setSelectedItems(rangeIds);
    } else {
      setSelectedItems([fullPath]);
      setLastSelectedIndex(index);
    }
  };
  const handleCheckboxChange = (fullPath, index) => {
    setLastSelectedIndex(index);
    setSelectedItems((prev) =>
      prev.includes(fullPath) ? prev.filter((x) => x !== fullPath) : [...prev, fullPath]
    );
  };

  const softDeleteS3EditorFolder = async (path) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Restore this folder!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Restore it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.path = path;
        userData.type = "restore";
        userData.fileManager = fileManager?.map(item => ({ fullPath: item.fullPath, location: item.location }));
        userData.studyId = studyId;
        let data =
          await editorS3FileManagerServices.softDeleteS3EditorFolder(
            userData
          );
        if (data?.statusCode === 200) {
          setFileFolderUpdater(Math.floor(1000000000 + Math.random() * 9000000000))
        }
      }
    });
  };

  const deleteS3EditorFolderFile = async (key) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Permanent Delete this folder!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Permanent Delete it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.key = key;
        userData.studyId = studyId;
        let data =
          await editorS3FileManagerServices.deleteS3EditorFolderFile(
            userData
          );
        if (data?.statusCode === 200) {
          getS3EditorFolders();
        }
      }
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideToolbar = AppsRef.current?.contains(event.target);
      const clickedInsideGrid = gridRef.current?.contains(event.target);
      const clickedInsideTable = tableRef.current?.contains(event.target);
      const clickedInMenu =
        event.target.closest(".node-menu") || event.target.closest(".kebab-icon");
      if (
        !clickedInsideToolbar &&
        !clickedInsideGrid &&
        !clickedInsideTable &&
        !clickedInMenu
      ) {
        setSelectedItems([]);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => document.removeEventListener("click", handleClickOutside, true);
  }, []);

  const isFile = (key) => {
    if (key) {
      const lastPart = key.split("/").filter(Boolean).pop() || "";
      const ext = lastPart.includes(".") ? lastPart.split(".").pop() : "";
      return ext;
    }
  };

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 34 }}
      >
        <div
          ref={AppsRef}
          className="hstack gap-1">
          {selectedItems?.length > 0 && (
            <>
              <i
                title="Permanent Delete Folder | File"
                className="fa-solid fa-trash-alt text-danger CP"
                onClick={() => deleteS3EditorFolderFile(selectedItems)}
              />
              <div className="vr"></div>
              <i
                title="Restore Folder | File"
                className="fa-solid fa-clock-rotate-left CP"
                onClick={() => softDeleteS3EditorFolder(selectedItems)}
              />
              <div className="vr"></div>
            </>
          )}
          <div className="position-relative">
            <Form.Control
              type="search"
              onChange={(e) => setSearchData(e.target.value)}
              value={searchData}
              placeholder="Search..."
              style={{ width: 250, padding: "3px 10px" }}
            />
            <CiSearch
              className="CP position-absolute bg-white"
              title="Search"
              style={{ width: 15, top: 4, right: 7 }}
            />
          </div>
        </div>

        <div className="hstack gap-2">
          <button
            className={`${viewType === "grid" && "text-white"} updateProfile`}
            style={{ backgroundColor: viewType === "grid" && "#103c5e" }}
            onClick={() => setViewType("grid")}
          >
            Grid View
          </button>
          <button
            className={`${viewType === "list" && "text-white"} updateProfile`}
            style={{ backgroundColor: viewType === "list" && "#103c5e" }}
            onClick={() => setViewType("list")}
          >
            List View
          </button>
        </div>
      </div>

      {/* Content Area */}
      <div className="overflow-auto" style={{ height: "calc(100vh - 182px)" }}>
        {loader ? (
          <PageLoader />
        ) : fileManager?.length === 0 ? (
          <NoDataFoundTable MSG={"File or Folder not found!"} />
        ) : (
          <>
            {/* GRID VIEW */}
            {viewType === "grid" && (
              <div ref={gridRef} className="d-flex flex-wrap">
                {fileManager?.map((item, index) => (
                  <div
                    key={item.name}
                    className={`text-center m-2 position-relative CP p-1 ${isSelected(item.fullPath) ? "selectedMenu br3" : ""
                      }`}
                    onClick={(e) => {
                      handleItemClick(e, item.fullPath, index)
                    }}
                    title={`Name: ${item.name}\nType: Folder\nSize: ${item.sizeMB}\nDeleted DT: ${item.deletedAt}\nUpdated DT: ${item.updatedAt}`}
                    style={{ width: 120, userSelect: "none" }}
                  >
                    <Form.Check
                      type="checkbox"
                      checked={isSelected(item.fullPath)}
                      onChange={() => handleCheckboxChange(item.fullPath, index)}
                      onClick={(e) => e.stopPropagation()}
                      className="position-absolute top-0 start-0 m-1"
                    />
                    {!item.isFile ? (
                      item?.children?.length > 0 ?
                        <>
                          {item?.name === "Uncategories" ?
                            <IoFolder className="text-info" style={{ fontSize: 60 }} />
                            :
                            <BsFillFolderFill className="text-warning" style={{ fontSize: 60 }} />
                          }
                        </>
                        :
                        <>
                          {item?.name === "Uncategories" ?
                            <IoFolder className="text-info" style={{ fontSize: 60 }} />
                            :
                            <FaFolder className="text-warning" style={{ fontSize: 60 }} />
                          }
                        </>
                    ) : (
                      <>
                        {isFile(item?.fullPath) === "csv" ?
                          <GrDocumentCsv className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                          : isFile(item?.fullPath) === "xpt" ?
                            <FaFile className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                            : (isFile(item?.fullPath) === "jpeg" || isFile(item?.fullPath) === "jpg" || isFile(item?.fullPath) === "png") ?
                              <BsImage className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                              : (isFile(item?.fullPath) === "xls" || isFile(item?.fullPath) === "xlsx") ?
                                <GrDocumentExcel className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                : isFile(item?.fullPath) === "pdf" ?
                                  <AiOutlineFilePdf className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                  : (isFile(item?.fullPath) === "doc" || isFile(item?.fullPath) === "docx") ?
                                    <GrDocumentWord className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                    : (isFile(item?.fullPath) === "ppt" || isFile(item?.fullPath) === "pptx") ?
                                      <GrDocumentPpt className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                      : (isFile(item?.fullPath) === "zip") ?
                                        <GoFileZip className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                        : isFile(item?.fullPath) === "txt" ?
                                          <GrDocumentTxt className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                          : isFile(item?.fullPath) === "rtf" ?
                                            <GrDocumentRtf className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                            :
                                            <FaFile className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                        }
                      </>
                    )}
                    <div className="mt-1 small text-truncate fontSize12">{item.name}</div>
                  </div>
                ))}
              </div>
            )}

            {/* LIST VIEW */}
            {viewType === "list" && (
              <Table
                className="m-0 custom-table"
                ref={(el) => {
                  tableDRef.current = el;
                  tableRef.current = el;
                }}
                borderless
                hover
              >
                <thead className="position-sticky top-0 z-1 bg-white">
                  <tr>
                    <th onMouseDown={(e) => onMouseDown(e, 0)}>Name</th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Original Location</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>
                      Deleted Date | Time
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>
                      Updated Date | Time
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>Type</th>
                    <th onMouseDown={(e) => onMouseDown(e, 5)}>Size</th>
                  </tr>
                </thead>
                <tbody>
                  {fileManager?.map((item, index) => (
                    <tr
                      key={item.name}
                      className={`${isSelected(item.fullPath) ? "selectedMenu" : ""
                        } CP`}
                      onClick={(e) => {
                        handleItemClick(e, item.fullPath, index)
                      }}
                      title={`Name: ${item.name}\nType: Folder\nSize: ${item.sizeMB}\nDeleted DT: ${item.deletedAt}\nUpdated DT: ${item.updatedAt}`}
                      style={{ userSelect: "none" }}
                    >
                      <td className="border-0">
                        <div className="hstack gap-2">
                          <Form.Check
                            type="checkbox"
                            checked={isSelected(item.fullPath)}
                            onChange={() =>
                              handleCheckboxChange(item.fullPath, index)
                            }
                            onClick={(e) => e.stopPropagation()}
                          />
                          <div style={{ width: 15 }}>
                            {!item.isFile ? (
                              item?.children?.length > 0 ?
                                <>
                                  {item?.name === "Uncategories" ?
                                    <IoFolder className="text-info" style={{ fontSize: 15 }} />
                                    :
                                    <BsFillFolderFill className="text-warning" style={{ fontSize: 15 }} />
                                  }
                                </>
                                :
                                <>
                                  {item?.name === "Uncategories" ?
                                    <IoFolder className="text-info" style={{ fontSize: 15 }} />
                                    :
                                    <FaFolder className="text-warning" style={{ fontSize: 15 }} />
                                  }
                                </>
                            ) : (
                              <>
                                {isFile(item?.fullPath) === "csv" ?
                                  <GrDocumentCsv className="text-secondary" style={{ fontSize: 15 }} />
                                  : isFile(item?.fullPath) === "xpt" ?
                                    <FaFile className="text-secondary" style={{ fontSize: 15 }} />
                                    : (isFile(item?.fullPath) === "jpeg" || isFile(item?.fullPath) === "jpg" || isFile(item?.fullPath) === "png") ?
                                      <BsImage className="text-secondary" style={{ fontSize: 15 }} />
                                      : (isFile(item?.fullPath) === "xls" || isFile(item?.fullPath) === "xlsx") ?
                                        <GrDocumentExcel className="text-secondary" style={{ fontSize: 15 }} />
                                        : isFile(item?.fullPath) === "pdf" ?
                                          <AiOutlineFilePdf className="text-secondary" style={{ fontSize: 15 }} />
                                          : (isFile(item?.fullPath) === "doc" || isFile(item?.fullPath) === "docx") ?
                                            <GrDocumentWord className="text-secondary" style={{ fontSize: 15 }} />
                                            : (isFile(item?.fullPath) === "ppt" || isFile(item?.fullPath) === "pptx") ?
                                              <GrDocumentPpt className="text-secondary" style={{ fontSize: 15 }} />
                                              : (isFile(item?.fullPath) === "zip") ?
                                                <GoFileZip className="text-secondary" style={{ fontSize: 15 }} />
                                                : isFile(item?.fullPath) === "txt" ?
                                                  <GrDocumentTxt className="text-secondary" style={{ fontSize: 15 }} />
                                                  : isFile(item?.fullPath) === "rtf" ?
                                                    <GrDocumentRtf className="text-secondary" style={{ fontSize: 15 }} />
                                                    :
                                                    <FaFile className="text-secondary" style={{ fontSize: 15 }} />
                                }
                              </>
                            )}
                          </div>
                          <span className="text-truncate">{item.name}</span>
                        </div>
                      </td>
                      <td className="border-0">{item.location}</td>
                      <td className="border-0">{item.deletedAt}</td>
                      <td className="border-0">{item.updatedAt}</td>
                      <td className="border-0">{!item.isFile ? "Folder" : <span className="text-uppercase">{isFile(item?.fullPath)}</span>}</td>
                      <td className="border-0">{item.sizeMB}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default RecycleBin;
